import { v4 as uuidv4 } from "uuid";
import SlotRenderEndedEvent from "../gpt/SlotRenderEndedEvent";

import Environment from "../util/Environment";
import Ad from "../gpt/Ad";
import TaglessAdHandler from "./TaglessAdHandler";
import { TaglessAdStyle } from "./type";
import { MOBILE_BREAK_POINT } from "./constants";

// NOTE: This is hardcoded API as this is just a POC to prove that this api works and renders ads correctly.
export const GAM_TAGLESS_API_ADS: string = `https://securepubads.g.doubleclick.net/gampad/ads?correlator=${ uuidv4() }&gdfp_req=1&enc_prev_ius=/0/1/2/3`;

// hardcoded sizes for only leaderboard for now
const AD_SIZES = window.innerWidth > MOBILE_BREAK_POINT ? [[970, 250]] : [[320, 50]];
const SCREEN_TYPE = window.innerWidth > MOBILE_BREAK_POINT ? "desktop" : "mobile";

const styles: { [key: string]: TaglessAdStyle } = {
    mobile: {
        iframeStyle:
            // set to 60px instead of 50px because some ads have a slight padding within the ad
            "height: 60px; width: 320px;"
    },
    desktop: {
        iframeStyle:
            "height: 250px; width: 970px"
    }
};

type UserConsentTargetings = Record<string, string>;

/**
 * @class TaglessAd
 */
export default class TaglessAd extends TaglessAdHandler {

    targetings: UserConsentTargetings;

    constructor(baseUrl: string = GAM_TAGLESS_API_ADS) {
        super(baseUrl);
        this.targetings = {};
    }

    // override tagless decorateAd
    decorateAd(iframe: HTMLIFrameElement, container: HTMLElement, googleIframeContainer: HTMLElement) {
        const currentStyle = styles[SCREEN_TYPE];

        googleIframeContainer.setAttribute("style", "border: 0pt none; width: 100%; height: 100%;");

        iframe.setAttribute("style", currentStyle.iframeStyle);

        iframe.setAttribute("scrolling", "no");
    }

    // override taglessHandler getAdSrc
    getAdSrc(ad: Ad): string | null {
        const adSizes = AD_SIZES.map((size) => {

            if (Array.isArray(size)) {
                const [width, height] = size;

                return `${ width }x${ height }`;
            }

            return "";
        }).join("|");

        const targeting_values = this.targetings;

        const targetings = Object.keys(this.targetings).map((key) => {
            const value = targeting_values[key];

            return `${ key }=${ value }`;

        })
            .join("&");

        const unitName = ad.getUnitName();
        const iuParts = unitName.split("/").join(",")
            .slice(1);

        const adParams = {
            prev_iu_szs: adSizes,
            iu_parts: iuParts
        };
        const searchParams = new URLSearchParams(adParams);

        const url = `${ this.baseUrl }&${ searchParams.toString() }&${ targetings }`;

        return url;
    }

    addTargeting(newTargeting: object): void {
        Object.assign(this.targetings, newTargeting);
    }

    // override taglessHandler render
    render(ad: Ad): void {

        const iframe = document.createElement("iframe");

        const containerId = ad.getContainerId();
        const id = ad.getId();

        const container = document.getElementById(containerId);
        const containerById: HTMLElement | null = document.getElementById(id);

        const url = this.getAdSrc(ad);

        if (!url || !container || !containerById) {
            return;
        }

        let googleIframeContainer = document.getElementById("google_ads_iframe");

        // logic needed to handle ad refresh not re-appending parent iframe container
        if (googleIframeContainer) {

            const newGoogleIframeContainer = document.createElement("div");

            newGoogleIframeContainer.id = "google_ads_iframe";

            containerById.replaceChild(newGoogleIframeContainer, googleIframeContainer);

            containerById.appendChild(newGoogleIframeContainer);
            newGoogleIframeContainer.appendChild(iframe);

            googleIframeContainer = newGoogleIframeContainer;

        } else {
            googleIframeContainer = document.createElement("div");
            googleIframeContainer.id = "google_ads_iframe";

            containerById.appendChild(googleIframeContainer);
            googleIframeContainer.appendChild(iframe);
        }

        iframe.title = containerId;
        iframe.src = url;

        this.decorateAd(iframe, container, googleIframeContainer);

        const newEvent = new SlotRenderEndedEvent({
            id: ad.getId(),
            adCode: ad.getUnitName(),
            requestTime: Environment.currentTime(),
            event: {
                advertiserId: ad.getId(),
                // Not sure how to get these exact values without the metadata tagless api for now
                campaignId: "TaglessCampaignId",
                lineItemId: "TaglessLineItemId",
                creativeId: "TaglessCreativeId",
                isEmpty: false,
                size: AD_SIZES[0]
            }
        });

        // Needed to handle hiding Advertisement text on ad

        ad.handleTaglessRenderEvent(newEvent);

        // Handle ALS tracking
        ad.handleSlotOnLoadEvent(undefined, iframe);
    }

}

